import { motion } from 'framer-motion';

function Intermediari({ rcProfessionalInsurances, privateInsurances, businessInsurances }) {
  return (
    <div className="mt-3 pt-5 pt-lg-0">
      <motion.h2
        className="fw-semibold"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        Sei un intermediario?
      </motion.h2>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Modello:</b>
        <br />
        Crediamo che il modello B2B2C sia la naturale estensione della nostra visione di ecosistema assicurativo phygitale. In questo schema, ogni attore ha un ruolo chiaro e sinergico: Greenia supporta le compagnie nello sviluppo di prodotti innovativi e mette a disposizione degli intermediari una piattaforma proprietaria, potenziata dall’intelligenza artificiale, progettata per semplificare il lavoro quotidiano e migliorare l’esperienza cliente.
        I nostri intermediari restano titolari esclusivi del proprio portafoglio e valorizzano il rapporto personale con i clienti, elemento chiave in un mercato che richiede fiducia, prossimità e competenza. Nessuna sovrapposizione, solo collaborazione: Greenia non si sostituisce mai all’intermediario, ma lo potenzia.
        Il risultato? Un’offerta assicurativa coerente, trasparente e personalizzata, erogata attraverso strumenti digitali collaudati e con la consulenza diretta dell’agente o broker di fiducia.
      </motion.p>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.4, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Soluzioni:</b>
      </motion.p>
      <ul>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
        >
          Emissione e gestione documentale
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6, duration: 0.5, ease: 'linear' }}
        >
          Gestione amministrativa e contabile
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.7, duration: 0.5, ease: 'linear' }}
        >
          Supporto completo nel post-vendita
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.8, duration: 0.5, ease: 'linear' }}
        >
          Monitoraggio, controllo e analisi del portafoglio
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.9, duration: 0.5, ease: 'linear' }}
        >
          Delega nella gestione sinistri
        </motion.li>
        <motion.li
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 1, duration: 0.5, ease: 'linear' }}
        >
          Statistiche sinistri e costi di gestione con analisi predittive
        </motion.li>
      </ul>

      <motion.p
        className="mt-5"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5, duration: 0.5, ease: 'linear' }}
        viewport={{ once: true }}
      >
        <b>Prodotti:</b>
      </motion.p>

      <div className="row g-3">
        <div className="col-12 col-md-6 col-lg-4">
          <motion.h3
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7, duration: 0.3, ease: 'linear' }}
            viewport={{ once: true }}
          >
            Polizze Privati
          </motion.h3>
          {privateInsurances.map((item, index) => (
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: item.delay, duration: 0.5, ease: 'linear' }}
              viewport={{ once: true }}
              key={index}
              className="bg-success px-2 py-3 rounded-3 shadow text-white fw-medium d-flex align-items-center justify-content-center my-1"
            >
              <p className="m-0">{item.name}</p>
            </motion.div>
          ))}
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <motion.h3
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7, duration: 0.3, ease: 'linear' }}
            viewport={{ once: true }}
          >
            Polizze RC Professionali
          </motion.h3>
          {rcProfessionalInsurances.map((item, index) => (
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: item.delay, duration: 0.5, ease: 'linear' }}
              viewport={{ once: true }}
              key={index}
              className="bg-success px-2 py-3 rounded-3 shadow text-white fw-medium d-flex align-items-center justify-content-center my-1"
            >
              <p className="m-0">{item.name}</p>
            </motion.div>
          ))}
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <motion.h3
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7, duration: 0.3, ease: 'linear' }}
            viewport={{ once: true }}
          >
            Polizze Business
          </motion.h3>
          {businessInsurances.map((item, index) => (
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: item.delay, duration: 0.5, ease: 'linear' }}
              viewport={{ once: true }}
              key={index}
              className="bg-success px-2 py-3 rounded-3 shadow text-white fw-medium d-flex align-items-center justify-content-center my-1"
            >
              <p className="m-0">{item.name}</p>
            </motion.div>
          ))}
        </div>
      </div>

    </div>
  );
}

export default Intermediari;
